<template>
	<!-- only attempts to access currentSheet properties once they are actually loaded -->
  <div @click="hideVariantEditingControls">
    <div id="tweakMenuCon" class="tweak-menu-hidden">
      <div class="tweak__buttons">
        <button id="tweakButton" class="btn" title="Tweak" @click.stop="createVariant()">
          Tweak it
        </button>
      </div>
      <span class="tweak__triangle"></span>
    </div>

    <div id="tweakAgainMenuCon" class="tweak-menu-hidden">
      <div class="tweak__buttons">
        <button id="tweakAgainButton" class="btn" title="Tweak" @click.stop="createAnotherVariant()">
          Tweak it
        </button>
      </div>
      <span class="tweak__triangle"></span>
    </div>

    <div id="variantMenuContainer">
      <div id="variantMenu" v-if="currentVariantChoices">
        <div id="variantMenuContentsContainer" class="card">
          <ul>
            <li class="choice" v-for="(choice, index) in currentVariantChoices" :key="index"
              @click.stop="setAsCurrentBest(choice, index)">
              {{ choice }}
              <i class="material-icons delete right" @click.stop="deleteChoice(index)">clear</i>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div v-if="currentSheet" class="container">
      <div id="sheetContainer" class="card">
        <p id="savingFeedback" v-if="autoSaveTimer">Saving...</p>
        <p id="savingFeedback" v-if="!autoSaveTimer">Saved</p>
        <input type="text" class="titleField browser-default" placeholder="Untitled" v-model="currentSheet.title">
        <span id="contentField" @mouseup="triggerTweakMenu" @input="onEdit" contenteditable="true" placeholder="Let's get tweaky..."></span>
        <!-- <span @mouseup="triggerTweakMenu" @input="onEdit" contenteditable="true" placeholder="Tweakin' starts here...">
          <span class="variant">Variant Span Border Testing</span>
        </span> -->
      </div>
      <!-- <span @click="test1">Span test</span> -->
      <!-- <button class="save-button btn-small btn-flat" @click="saveSheet">Save</button> -->
      
      <!-- <button class="test-button btn-small btn-flat" @click="test2">bind Variants Events</button> -->
      <!-- <button class="test-button btn-small btn-flat" @click="test3">Clear current variant choices</button> -->
      <!-- <button class="test-button btn-small btn-flat" @click="test4">Console Variant Controllers</button> -->
    </div>
  </div>
  
</template>


<script>
import { db } from '@/helpers/firebase'
import $ from 'jquery'
export default {
  name: 'EditSheet',
  data () {
    return {
      currentSheet: null,
      sheetRef: null,
      selection: null,
      currentVariantChoices: null,
      currentVariantSpan: null,
      testVariable: 'hello',
      autoSaveTimer: null
    }
  },
  created() {
    this.getCurrentSheet()
  },
  mounted() {
    setTimeout( this.bindVariantEvents, 1000 )
    this.getVariantControllers()
  },
  computed: {
    variantControllers() {
      return this.$store.getters.variantControllers(this.$route.params.sheet_id)
    }
  },
  methods: {
    test1(){
      //$( "#contentField" ).innerHTML(this.currentSheet.content)
      console.log('test1 method ran')
    },
    test2(){
      console.log('clicked choice delete button')
    },
    test3(){
      this.currentVariantChoices = null
    },
    test4(){
    console.log(this.variantControllers)
    },
    getVariantControllers() {
      this.$store.dispatch('bindVariantControllers')
    },
    getCurrentSheet() {
      //Query 'sheets' using sheet_id and fill currentSheet variable with the result
      this.sheetRef = db.collection('sheets').doc(this.$route.params.sheet_id)
    
      this.sheetRef.get().then((doc) => {
      if (doc.exists) {
          this.currentSheet = doc.data()
          this.currentSheet.id = doc.id
          let refContent = this.currentSheet.content
          setTimeout(function(){ $( "#contentField" ).html(refContent) }, 0)
        }
      })
    },
    onEdit(evt){
      var src = evt.target.innerHTML
      this.currentSheet.content = src
      
      this.autoSave()
    },
    autoSave() {
      clearTimeout(this.autoSaveTimer)
      //console.log('timer cleared')
      
      this.autoSaveTimer = setTimeout(this.saveSheet, 3000)
      
      //console.log('timer set')
      
    },
    saveSheet() {
      var strippedHtml = $("#contentField").text().substring(0, 240).trim()
      strippedHtml += '...'
      this.currentSheet.content = $("#contentField").html()
      this.sheetRef.update({
        title: this.currentSheet.title,
        content: this.currentSheet.content,
        summary: strippedHtml
        //add date updated for proper dashboard sorting
        })
      // console.log("currentSheet.content: " + this.currentSheet.content)
      // console.log("sheetRef.summary: " + this.sheetRef.summary)
      console.log('saveSheet run')
      
      this.autoSaveTimer = null
    },
    hideVariantEditingControls() {
      this.hideTweakMenu()
      this.hideTweakAgainMenu()
      this.currentVariantChoices = null
      // console.log('hideVariantEditingControls ran')
    },
    hideTweakMenu() {
      var menu = $( "#tweakMenuCon" )
      menu.attr("class","tweak-menu-hidden")
      menu.css("left", "0")
      menu.css("top", "0")
      // console.log('hideTweakMenu run')
    },
    showTweakAgainMenu(span) {
      var spanRect = span.getBoundingClientRect()
      var menuAgain = $( "#tweakAgainMenuCon")
      var spanCenter = spanRect.width / 2
      var menuAgainWidthOffset = 47
      var menuAgainOffset = spanCenter - menuAgainWidthOffset
      menuAgain.attr("class", "tweak-menu-shown")
      menuAgain.css("left", ( spanRect.left + menuAgainOffset ) + 'px')
      menuAgain.css("top", ( spanRect.top - 50 ) + 'px')
    },
    hideTweakAgainMenu() {
      var menuAgain = $( "#tweakAgainMenuCon" )
      menuAgain.attr("class", "tweak-menu-hidden")
      menuAgain.css("left", "0")
      menuAgain.css("top", "0")
      // console.log('hideTweakAgainMenu run')
    },
    triggerTweakMenu() {
      setTimeout( this.showTweakMenu, 100 )
    },
    showTweakMenu() {
      // immediately invoke getHighlight() and fill the variable ‘highlight” with the object it returns
      var highlight = this.getHighlight()
      // Create a local variable, ‘menu’, and use it to reference the tweak menu div
      var menu = $( "#tweakMenuCon" )
      // Check if any text was actually selected, if not, hide the tweak it menu and return it to its top left resting position
      if ( highlight.text === '' || highlight.parent.className == 'variant' ) {
        menu.attr("class","tweak-menu-hidden")
        menu.css("left", "0")
        menu.css("top", "0")
        //this.currentVariantChoices = null
        return
      }
      var selectionRectCenter = highlight.rect.width / 2
      // This is the total width of the tweak it menu, divided by two. 
      // We will use this to “slide” the menu back to the left so the center of the menu lines up with the center of the selection rectangle, 
      // instead of the left side of the menu lining up with it
      var menuWidthOffset = 47
      var menuOffset = selectionRectCenter - menuWidthOffset
      menu.attr("class"," tweak-menu-shown")
      menu.css("left", ( highlight.rect.left + menuOffset) + 'px')
      menu.css("top",  ( highlight.rect.top - 50 ) + 'px')
    },
    getHighlight() {
      
      var currentSelection = window.getSelection()
      var object = {
        parent: null,
        text: '',
        rect: null
      }
      // If selection is not empty.
      if ( currentSelection.rangeCount > 0 ) {
        object = {
          parent: currentSelection.anchorNode.parentElement,
          text: currentSelection.toString().trim(),
          rect: currentSelection.getRangeAt(0).getBoundingClientRect()
        }
      }
      this.selection = object
      return object
    },
    createVariant() {
      // If there is a selection, create a new variant controller and use its returned ID to set a custom class for the soon to be created span tag
      
      db.collection('variant-controllers').add({
        choices: [ this.selection.text ],
        parentSheet: this.currentSheet.id
        
      }).then( (doc) => {        
        // Create a new parent object of type span that will be configured and then wrapped around the selected text in the sheet
        const parentSpan = document.createElement("span")
        // Add variant class to parentSpan
        parentSpan.className = "variant"
        
        // Add a unique id to parentSpan
        parentSpan.id = doc.id
        window.getSelection().getRangeAt(0).surroundContents(parentSpan)
        // Create left variant handle element
        var leftHandle = $('<span class="variant-handle" contenteditable="false">&nbsp</span>')
        // Create right variant handle element
        var rightHandle = $('<span class="variant-handle" contenteditable="false">&nbsp</span>')
        // Insert left handle inside of parent span & before variant text
        $( parentSpan ).prepend( leftHandle )
        // Insert right handle after parent span
        $( parentSpan ).append( rightHandle )
        var src = $( "#contentField" ).html()
        this.currentSheet.content = src
        parentSpan.addEventListener("click", (e) => {
          e.stopPropagation()
          this.loadVariants(parentSpan)
        })
        this.autoSave()
      })
    },
    createAnotherVariant() {
      this.currentVariantChoices.push(this.currentVariantSpan.textContent)
      db.collection('variant-controllers').doc(this.currentVariantSpan.id).update({
        choices: this.currentVariantChoices
      })
    },
    deleteChoice(index) {
      this.currentVariantChoices.splice(index, 1)
      db.collection('variant-controllers').doc(this.currentVariantSpan.id).update({
        choices: this.currentVariantChoices
      })
    },
    bindVariantEvents() {
      var that = this
      var variantSpans = document.querySelectorAll(".variant")
    
      variantSpans.forEach(function(span) {
        span.addEventListener("click", (e) => {
          e.stopPropagation()
          that.loadVariants(span)
        })
      }) 
      // console.log('binded events')
    },
    loadVariants(span) {
      this.showTweakAgainMenu(span)
      this.positionVariantMenuContainer()
      var that = this
      var clickedVariantController = null
      this.currentVariantSpan = span
      this.variantControllers.forEach(function(controller){
        if (controller.id == that.currentVariantSpan.id){
          clickedVariantController = controller
        }
      }) 
      this.currentVariantChoices = clickedVariantController.choices
    },
    positionVariantMenuContainer() {
      var variantMenuContainer = $( "#variantMenuContainer" )
      var sheetContainer = $( '#sheetContainer' )
      var newLeftPosition = sheetContainer.position().left + sheetContainer.width() + 80
      //newLeftPosition += sheetContainer.width()
      variantMenuContainer.css("left", newLeftPosition)
      variantMenuContainer.css("visibility", 'visible')
    },
    setAsCurrentBest(selectedChoice, index) {
      // Get a copy of the previous current variant’s text from between the span tags before overwriting it with the new choice
      // This Is so in the future we can push it back into the variantChoices array and then update that document in Firebase
      var oldVariantText = this.currentVariantSpan.textContent.trim()
      // console.log("old variant text: " + oldVariantText)
      // Change the actual text the user sees, in the content field div
      //this.currentVariantSpan.textContent = selectedChoice
      $( this.currentVariantSpan ).contents().filter(function () {
        return this.nodeType === 3 
      }).remove()
      
      // $( "" + this.currentVariantSpan + ":first-child" ).after(selectedChoice)
      $( this.currentVariantSpan.firstChild ).after(selectedChoice)
      // console.log( this.currentVariantSpan.firstChild )
  
      // this.currentVariantSpan.append( selectedChoice )
      // console.log("selected variant: " + selectedChoice)
      
      // Splice it from the array by its index if possible. 
      // Do before adding the old variant text back to the array so the indexes remain intact
      this.currentVariantChoices.splice(index, 1)
      // Add oldVariantText to the currentVariantChoices array before it gets used to update the old document in Firebase
      this.currentVariantChoices.push(oldVariantText)
      // console.log("current variant choices: " + this.currentVariantChoices)
      db.collection('variant-controllers').doc(this.currentVariantSpan.id).update({
        choices: this.currentVariantChoices
      })
      this.saveSheet()
      console.log('database updated with variants')
    }
  }
}
</script>

<style scoped>
body {
  background-color: red
}
.container {
  margin-top: 40px;
  max-width: 960px;
}
#sheetContainer.card {
  border-radius: 15px;
  height: auto;
  min-height: 90vh;
  padding: 25px 40px 40px 40px;
}
.save-button {
  background-color: #D55672;
  color: #F8F8F8;
  cursor: pointer
}
.test-button {
  background-color: #333333;
  color: #f8f8f8;
  margin-left: 10px;
}
::selection {
  background-color: #19a3bf69;
  opacity: 0.5;
}
#variantMenuContainer{
  position: absolute;
  visibility: hidden;
  height: 100vh;
  z-index: 400;
  top: 0px;
  height: 100vh;
}
#variantMenu{
  position: absolute;
  height: 100vh;
  min-width: 400px;
  top: 0px;
  padding: 20px;
  font-size: 1.2em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* background-color: blue; */
}
#variantMenuContentsContainer.card{
  border-radius: 10px;
  background-color: white;
  padding: 0px 20px;
}
.choice{
  padding: 10px;
  cursor: pointer;
}
.choice:hover{
  margin: 3px 0px;
  transition: margin 4.00s ease-in-out;
  padding-left: 15px;
  cursor: pointer;
  border-left: 4px solid #19A3BF;
  transition: border-width 0.10s ease-in-out;
}
/* #variantMenu .card {
  height: 100px;
} */
.titleField {
  font-size: 2em !important;
  border: none !important;
  height: 3rem;
  width: 100%;
  margin: 0 0 8px 0;
  padding: 0;
  box-sizing: content-box;
  background-color: transparent;
}
.titleField:focus {
  border: none !important;
  outline: none !important;
}
#contentField {
  font-size: 1.4em !important;
  height: 100%;
  min-height: 80vh;
  display: inline-block;
  /* border: none; */
  outline: none;
  /* resize: none; */
  /* background-color: green; */
}
[contenteditable=true]:empty:before {
  content: attr(placeholder);
  pointer-events: none;
  display: block;
  color: #D1D1D1;
  min-height: 100%;
  /* background-color: blue; */
}
.tweak-menu-hidden {
  position: absolute;
  visibility: hidden;
  top: 0;
  left: 0;
  z-index: 500;
  -webkit-transform: translateY(-5px);
          transform: translateY(-5px);
  -webkit-transition: -webkit-transform 0.25s ease-in-out;
  transition: -webkit-transform 0.25s ease-in-out;
  transition: transform 0.25s ease-in-out;
  transition: transform 0.25s ease-in-out, -webkit-transform 0.25s ease-in-out;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.3);
  background-color: #F8F8F8 !important;
  border-radius: 3px;
}
.tweak-menu-shown {
  position: absolute;
  visibility: visible;
  z-index: 500;
  -webkit-transform: translateY(0);
          transform: translateY(0);
  transition: -webkit-transform 0.25s ease-in-out;
  transition: transform 0.25s ease-in-out;
  transition: transform 0.25s ease-in-out, -webkit-transform 0.25s ease-in-out;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.3);
  background-color: #F8F8F8 !important;
  border-radius: 3px;
}
#tweakButton {
  background-color: #19A3BF;
  /* background-color: #D55571; */
  text-transform: none;
  border-radius: 3px;
  font-size: 1.2em;
}
#tweakAgainButton {
  background-color: #19A3BF;
  text-transform: none;
  border-radius: 3px;
  font-size: 1.2em;
}
.tweak__buttons {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  position: relative;
  z-index: 450;
  overflow: hidden;
}
.tweak__triangle {
  background-color: #19A3BF;
  width: 18px;
  height: 18px;
  position: absolute;
  bottom: 12px;
  left: 50%;
  z-index: 400;
  border-radius: 3px;
  -webkit-transform: translate3d(-50%, 100%, 0) rotate(45deg);
          transform: translate3d(-50%, 100%, 0) rotate(45deg);
}
#savingFeedback {
  position: absolute;
  top: 4px;
  right: 26px;
  color: #aaa;
  cursor: default;
}
.delete {
  color: #aaa;
  cursor: pointer;
}
.delete:hover {
  color: #D55672;
}
.variant-handle{
  display: inline-block;
  width: 100px;
  color: orange;
}
</style>